import { type OddsFormat } from '@cx-web/domain-types';
import { CookieService } from '@cx-web/feature-cookies';
import TrackingActions, { TRACKING_ACTIONS, TRACKING_CATEGORIES, TRACKING_EVENTS } from '@cx-web/feature-tracking';

const ONE_DAY = 86_400_000;

export function changeOddsFormat(newOddsFormat: OddsFormat): void {
  new CookieService().select('odds_format').set(newOddsFormat, Date.now() + ONE_DAY);

  new TrackingActions().eventTracking({
    event: TRACKING_EVENTS.CHANGE_ODDS_FORMAT,
    eventCategory: TRACKING_CATEGORIES.ODDS_FORMAT,
    eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.CHANGE_ODDS_FORMAT],
    eventLabel: newOddsFormat,
  });

  // TODO: CI-1135 replace hard refresh with revalidate
  window.location.reload();
}
